export const ImageAlwaysOnRight = true;
//# sourceMappingURL=ImageAlwaysOnRight.js.map